import React from 'react'
import tabbu from '../../Images/tabbu-rajput.png'
import nucosmetics from '../../Images/nucosmetic.webp'
import startupkhata from '../../Images/StartupKhatalogo.png'
import rapidtax from '../../Images/rapidtax.webp'

function HomeClients() {

    return (
        <>
            <div className="container-fluid client-bg">
                <div className="container-xl">
                    <div className="row py-3">
                        <div className="col industries">
                            <h1>Our Clients <span>Review</span></h1>
                        </div>
                    </div>
                    <div id="carouselExampleControls" className="carousel slide text-center carousel-dark" data-mdb-ride="carousel">
                        <div className="carousel-inner ">
                            <div className="carousel-item active">
                                <div className="client-img">
                                    <img loading="lazy" width="100%" height='100%' className="client-img-section  mb-4"
                                        src={tabbu} alt="Client Reviews"
                                        style={{ width: "150px" }} />
                                </div>
                                <div className="row d-flex justify-content-center py-2">
                                    <div className="col-lg-6 col-11 col-sm-8">
                                        <div className="row text-muted">
                                            <div className="col-lg-11 col-12 col-sm-11 text-muted-inner">
                                                <h5 className="mb-3">Tabbu Rajput</h5>
                                                <p className=" ">
                                                    <i className="fas fa-quote-left pe-2"></i>
                                                    I am very impressed by the quality of work that Waywys delivers. They have designed and developed a stunning website for my brand, and also provided me with effective digital campaigns. They are very professional and easy to work with.
                                                </p>
                                            </div>
                                            <ul className="list-unstyled d-flex justify-content-center text-warning mb-3">
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="far fa-star fa-sm"></i></li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="carousel-item">
                                <div className="client-img">
                                    <img loading="lazy" width="100%" height='100%' className="client-img-section  mb-4"
                                        src={nucosmetics} alt="Client Reviews"
                                        style={{ width: "150px" }} />
                                </div>
                                <div className="row d-flex justify-content-center py-2">
                                    <div className="col-lg-6 col-11 col-sm-8">
                                        <div className="row text-muted">
                                            <div className="col-lg-11 col-12 col-sm-11 text-muted-inner">
                                                <h5 className="mb-3">NU COsmetics</h5>
                                                <p className=" ">
                                                    <i className="fas fa-quote-left pe-2"></i>
                                                    Waywys is a great partner for our digital marketing needs. They have helped us increase our online presence by 10x, reach new customers, and grow our business overall. Super responsive and creative team. Highly recommended.
                                                </p>
                                            </div>
                                            <ul className="list-unstyled d-flex justify-content-center text-warning mb-3">
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="far fa-star fa-sm"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="carousel-item">
                                <div className="client-img">
                                    <img loading="lazy" width="100%" height='100%' className="client-img-section  mb-4"
                                        src={startupkhata} alt="Client Reviews"
                                        style={{ width: "150px" }} />
                                </div>
                                <div className="row d-flex justify-content-center py-2">
                                    <div className="col-lg-6 col-11 col-sm-8">
                                        <div className="row text-muted">
                                            <div className="col-lg-11 col-12 col-sm-11 text-muted-inner">
                                                <h5 className="mb-3">Startup Khata</h5>
                                                <p className=" ">
                                                    <i className="fas fa-quote-left pe-2"></i>
                                                    Waywys has been a game-changer for our startup. They have helped us launch our product, and reach a wide audience through their innovative digital marketing solutions. They are always on top of the latest trends and technologies, and they are very friendly and supportive.
                                                </p>
                                            </div>
                                            <ul className="list-unstyled d-flex justify-content-center text-warning mb-3">
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="far fa-star fa-sm"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="carousel-item">
                                <div className="client-img">
                                    <img loading="lazy" width="100%" height='100%' className="client-img-section  mb-4"
                                        src={rapidtax} alt="Client Reviews"
                                        style={{ width: "150px" }} />
                                </div>
                                <div className="row d-flex justify-content-center py-2">
                                    <div className="col-lg-6 col-11 col-sm-8">
                                        <div className="row text-muted">
                                            <div className="col-lg-11 col-12 col-sm-11 text-muted-inner">
                                                <h5 className="mb-3">Rapid Tax</h5>
                                                <p className=" ">
                                                    <i className="fas fa-quote-left pe-2"></i>
                                                    "Working with Waywys has been an incredible experience. From start to finish, they demonstrated professionalism, expertise, and a genuine commitment to delivering exceptional service.
                                                </p>
                                            </div>
                                            <ul className="list-unstyled d-flex justify-content-center text-warning mb-3">
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="fas fa-star fa-sm"></i></li>
                                                <li><i className="far fa-star fa-sm"></i></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Previous</span>
                        </button>
                        <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default HomeClients